export default __webpack_public_path__ + "static/media/about-team-16.71e871b4.png";